import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIMES } from '../../shared/providers/react-query-provider';

import { getCalendarStatus } from './api';
import { CalendarStatus } from './types';

export const getCalendarStatusQueryKey = () => ['calendarConfig', 'status'] as const;

export const useGetCalendarStatus = () =>
    useQuery<CalendarStatus>({
        queryKey: getCalendarStatusQueryKey(),
        queryFn: getCalendarStatus,
        staleTime: QUERY_STALE_TIMES.AGENT_SETTINGS,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
